import React, { useEffect, useRef, useState } from 'react';
import IncidentNavigationBar from './IncidentNavigationBar';
import './RequestPage.css';

const ChangeRequestDocsPage = () => {
  const redocDiv = useRef(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let spec = null;
    fetch('/config.json')
      .then(res => res.json())
      .then(config => {
        const baseUrl = config.API_BASE_URL;
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const domain = isLocalhost && config.DOMAIN
          ? config.DOMAIN.replace("https://", "").replace("http://", "").replace("-api-explorer", "")
          : window.location.hostname.replace('https://', '').replace('http://', '').replace('-api-explorer', '');
        return fetch(`${baseUrl}wolken-secure/openapi/itsm/change_request`, { credentials: 'include', headers: { domain } });
      })
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch OpenAPI spec');
        return res.json();
      })
      .then(json => {
        spec = json;
        function initRedocWhenReady() {
          if (redocDiv.current) {
            window.Redoc.init(spec, {}, redocDiv.current);
            setLoading(false);
          } else {
            setTimeout(initRedocWhenReady, 50);
          }
        }
        if (!window.Redoc) {
          const script = document.createElement('script');
          script.src = 'https://cdn.jsdelivr.net/npm/redoc@next/bundles/redoc.standalone.js';
          script.onload = () => {
            initRedocWhenReady();
          };
          document.body.appendChild(script);
        } else {
          initRedocWhenReady();
        }
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <IncidentNavigationBar />
      <div id="content-div" style={{ marginTop: '2rem', position: 'relative' }}>
        <div ref={redocDiv}></div>
        {loading && (
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'rgba(255,255,255,0.8)', zIndex: 1
          }}>
            <div style={{ fontSize: '1.2rem' }}>Loading API documentation...</div>
          </div>
        )}
        {error && (
          <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem', position: 'absolute', width: '100%' }}>
            Error: {error}
          </div>
        )}
      </div>
    </>
  );
};

export default ChangeRequestDocsPage;
